export let cursor = {
	target: null,
	init: function(){
		cursor.target = document.querySelector(".cursor");
		let currentX = window.innerWidth / 2;
		let currentY = window.innerHeight / 2;
		
		let mouseX = currentX;
		let mouseY = currentY;
		
		const speed = 0.12;
		
		// マウス移動を検知
		document.documentElement.addEventListener('mousemove', (e) => {
			mouseX = e.clientX;
			mouseY = e.clientY;
		});
		// アニメーションループで滑らかに追従
		const animate = () => {
			currentX += (mouseX - currentX) * speed;
			currentY += (mouseY - currentY) * speed;
		
			cursor.target.style.transform = `translate(${currentX}px, ${currentY}px)`;
		
			requestAnimationFrame(animate);
		};
		animate();
		
		// デフォルトカーソルを非表示
		document.body.style.cursor = 'none';
	}
}